/**
 * Auth component auth stage options.
 * Treat this file as an enum.
 * @module authStages
 * @category Auth
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * The sign up (email and password) portion of the sign up flow
 */
export const SIGN_UP = "SIGN_UP";

/**
 * The sign in (email and password) portion of the sign in flow
 */
export const SIGN_IN = "SIGN_IN";

/**
 * The profile setup portion of the sign up flow
 */
export const PROFILE = "PROFILE";
